import { isEmpty } from './isBlank';

/**
 * Renvoie la distance entre deux points en mêtres
 * @param origine
 * @param destination
 */
export function distance(
  origine: { gps_x?: string; gps_y?: string },
  destination: { gps_x?: string; gps_y?: string }
): number | undefined {
  if (!origine || isEmpty(origine.gps_x) || isEmpty(origine.gps_y)) return undefined;
  if (!destination || isEmpty(destination.gps_x) || isEmpty(destination.gps_y)) return undefined;

  const lat1 = +origine.gps_y;
  const lon1 = +origine.gps_x;
  const lat2 = +destination.gps_y;
  const lon2 = +destination.gps_x;

  // Convert latitude and longitude from degrees to radians
  const radLat1 = (Math.PI * lat1) / 180;
  const radLon1 = (Math.PI * lon1) / 180;
  const radLat2 = (Math.PI * lat2) / 180;
  const radLon2 = (Math.PI * lon2) / 180;

  // Calculate the difference between the latitudes and longitudes
  const diffLat = radLat2 - radLat1;
  const diffLon = radLon2 - radLon1;

  // Apply the Haversine formula
  const a = Math.sin(diffLat / 2) ** 2 + Math.cos(radLat1) * Math.cos(radLat2) * Math.sin(diffLon / 2) ** 2;
  const c = 2 * Math.asin(Math.sqrt(a));

  // Earth's radius in meters (you can adjust this for more precision)
  const earthRadius = 6371000; // or 6378137 for WGS84 ellipsoid

  // Calculate the distance
  return earthRadius * c;
}
